import { computed, makeObservable } from 'mobx';
import { FiltersStateStrategyType, FilterType } from 'src/domains/layouts/webview/components/filters/Filters.state';
import { MatchType } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/markets';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';

export class UnifiedSportMarketFilterStrategy implements FiltersStateStrategyType<MatchType | null> {
    public constructor(private readonly eventsListState: UnifiedSportEventsListState) {
        makeObservable(this);
    }

    @computed public get filters(): FilterType<MatchType>[] {
        return this.eventsListState.marketForEnv.map((item) => ({
            id: item.id,
            key: item.id,
            label: item.name,
        }));
    }

    public getActiveFilterId(): MatchType | null {
        return this.eventsListState.filter_market;
    }

    public setActiveFilterId(id: string | number | null): void {
        if (typeof id !== 'string') {
            return;
        }

        const isValidMarket = this.eventsListState.marketForEnv.some((market) => market.id === id);

        if (isValidMarket === true) {
            this.eventsListState.changeFilter_market(id as MatchType);
        }
    }
}
